//Core
import React from "react"

//styles
import style from "./style.module.scss"

//Components
import MenuList from "./MenuList"

const bigMenu = [
  {
    text: "Тобі",
    link: "/you/cards",
  },
  {
    text: "Eквайринг",
    link: "/your-business/trading-acquiring",
  },
  {
    text: "Малому та середньому бізнесу",
    link: "https://tas24b.ua",
  },
  {
    text: "Корпоративному бізнесу",
    link: "/corp-business",
  },
  {
    text: "Private Banking",
    link:
      "https://old.tascombank.ua/index.php?option=com_content&task=view&id=642&Itemid=208",
  },
]

const sunMenu = [
  {
    text: "Про банк",
    link: "/our-team",
  },
  {
    text: "Новини",
    link: "/news",
  },
  {
    text: "Карта відділень",
    link: "/branch",
  },
  {
    text: "Контакти",
    link: "/contacts",
  },
]

const Menu = () => {
  return (
    <div className={style.MenuWrapper}>
      <MenuList menu={bigMenu}></MenuList>
      <MenuList menu={sunMenu}></MenuList>
    </div>
  )
}

export default Menu
